import * as store from '@attain-apps/fe/web/main/lib/store'
import type * as awsAmplifyAuth from 'aws-amplify/auth'

import type { Feature } from './feature'
import type { State } from './state'

/**
 * Core actions for this {@link Feature}
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    authenticate: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<{
        session: awsAmplifyAuth.AuthSession
      }>(),
      reducers: {
        success: ({
          state,
          data: {
            response: { session },
          },
        }) => ({
          ...state,
          session,
        }),
        error: ({ state, data: { error } }): State => ({
          ...state,
          error,
        }),
      },
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
